import { Layout, Typography } from "antd";
import pallete from "../utils/pallete";

export default function Footer() {
  return (
    <Layout.Footer
      style={{ backgroundColor: '#fff', padding: '12px 25px' }}
    >
      <Typography.Text style={{ fontSize: 12, color: pallete.grey[600], fontWeight: 400 }} >
        &copy;{new Date().getFullYear()}. KEMENP2MI - All Rights Reserved.
      </Typography.Text>
    </Layout.Footer>
  )
}